import angular from 'angular';
import invoiceCreateWizardComponent from './invoice-create-wizard.component';

let invoiceCreateWizardModule = angular.module('invoiceCreateWizard', [])
  .component('invoiceCreateWizard', invoiceCreateWizardComponent);

export default invoiceCreateWizardModule;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-create-wizard/invoice-create-wizard.js